<template>
  <v-container class="pa-4" fluid>
    <v-btn text @click="$router.back()">
      <v-icon left>mdi-arrow-left</v-icon> {{ $t("back") }}
    </v-btn>

    <h2 class="my-4 font-weight-bold">
      {{ $route.params.id ? $t("update") : $t("add") }} {{ $t("category") }}
    </h2>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="form.name"
        :label="$t('category_name')"
        :rules="[rules.required]"
        :placeholder="$t('enter_category_name')"
        required
        outlined
        dense
      />

      <v-btn
        :loading="loading"
        color="#ECB939"
        class="black--text mt-4 px-5"
        @click="submit"
      >
        {{ $route.params.id ? $t("update") : $t("add") }}
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import api from "../services/axios";
export default {
  data() {
    return {
      valid: false,
      loading: false,
      form: {
        name: "",
      },
      rules: {
        required: (v) => !!v || this.$t("field_required"),
      },
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchDetails();
    }
  },
  methods: {
    async fetchDetails() {
      try {
        const res = await api.get("/category/view/" + this.$route.params.id);
        const data = res.data.data;
        this.form.name = data.name;
      } catch (error) {
        console.error("Failed to load categories:", error);
      } 
    },
    async submit() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;

      this.loading = true;
      const payload = new FormData();
      payload.append("name", this.form.name);

      try {
        const res = await api.post(
          !this.$route.params.id
            ? "category/add"
            : "category/update/" + this.$route.params.id,
          payload,
          {
            headers: {
              Accept: "application/json",
              "Accept-Language": "en",
            },
          }
        );
       if (!res.data.status) {
            this.$root.$emit("show-snackbar", {
                message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
                color: "error",
            });
        }
        else {
            this.$root.$emit("show-snackbar", {
                message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
                color: "success",
            });
            this.form.name = "";
            this.$router.back();
        }
        
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
